import { Field } from '@/layout/fields'

export class SignatureField extends Field {
  get searchable () {
    return false
  }
}
